function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { EXPAND_ICON_POSITION } from 'swag-client-common/constants';
import Tooltip from 'swag-client-common/components/ui/tooltip';
import { Button } from 'swag-client-common/components/ui/button';
import CloseButton from 'swag-client-common/components/ui/close-button';
import appearAnimationClasses from '../../../../popups/filters-popup/components/filter-item/appear.anim.scss';
import fastAppearAnimationClasses from '../../../../../animations/fast-appear.anim.scss';
import { isAllSwagCategory } from '../../../../../redux/product-listing/product-listing.utils';
import classes from './header.scss';
const closeBtnStyles = {
  top: '14px',
  left: '-20px'
};
function Header({
  isCloseShown = false,
  isButtonShown = false,
  isExpandButtonShown = false,
  isButtonDisabled = false,
  isExpandable = false,
  expandIconPosition = EXPAND_ICON_POSITION.up,
  title = '',
  titleClassName = '',
  buttonText,
  buttonClassName = '',
  closeClassName = '',
  MiddleBlock,
  closeButtonStyle = {},
  onClose,
  onButtonClick
}) {
  return /*#__PURE__*/React.createElement("div", null, isCloseShown && /*#__PURE__*/React.createElement(CloseButton, {
    styles: _objectSpread({}, closeBtnStyles, closeButtonStyle)
    // @todo. auto generated. fix this error
    // @ts-ignore
    ,
    className: closeClassName,
    onClick: onClose
  }), isButtonShown && /*#__PURE__*/React.createElement(Button, {
    disabled: isButtonDisabled,
    onClick: onButtonClick,
    className: buttonClassName,
    type: "primary"
  }, buttonText), isExpandable && /*#__PURE__*/React.createElement(Button, {
    onClick: onButtonClick,
    className: classnames(classes.expandButton, {
      [classes.show]: isExpandButtonShown
    }),
    type: "default"
  }, expandIconPosition === EXPAND_ICON_POSITION.up ? /*#__PURE__*/React.createElement("div", {
    className: classes.tooltipWrapper
  }, /*#__PURE__*/React.createElement(Tooltip, {
    direction: "top",
    className: classes.tooltip,
    tooltipText: "See more products."
  })) : null, /*#__PURE__*/React.createElement(ExpandLessIcon, {
    className: classnames(classes.expandIcon, {
      [classes.rotate180]: expandIconPosition === EXPAND_ICON_POSITION.down,
      [classes.rotate90]: expandIconPosition === EXPAND_ICON_POSITION.left,
      [classes.rotate0]: expandIconPosition === EXPAND_ICON_POSITION.up
    }),
    color: "disabled",
    fontSize: "large"
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.header, titleClassName)
  }, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: appearAnimationClasses,
    in: !!title,
    timeout: 500,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: fastAppearAnimationClasses,
    key: title,
    timeout: 250
  }, /*#__PURE__*/React.createElement("h5", {
    className: classes.title
  }, title)))), MiddleBlock && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.middle, {
      [classes.indent]: isButtonShown
    })
  }, !isAllSwagCategory() && MiddleBlock)), isAllSwagCategory() && MiddleBlock);
}
export default Header;